import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { triggersClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertFolder($input: FolderInput) {
    upsertFolder(input: $input) {
      id
    }
  }
`

const cleanRequest = (field, value) => {
  switch (field) {
    default:
      return { [field]: value }
  }
}

const EditableFolder = ({ record, field, children, ...props }) => {
  const canEdit = useSessionPermission('editTrigger') && record.id !== 1
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, {
    refetchQueries: ['Folders', 'Folder'],
    client: triggersClient
  })

  const handleRequest = value => {
    const params = { variables: { input: { id: record.id, ...cleanRequest(field, value) } } }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} disabled={!canEdit} {...props}>
      {children}
    </Editable>
  )
}

export default EditableFolder
